<div
  class="page"
  [class.auth-page]="isAuthShell"
  [class.desktop-chat-open]="showDesktopChatOverlay || showDesktopAgentOverlay"
  [class.mobile-actions-shell]="showMobileHeaderActions"
  [class.mobile-footer-shell]="showMobileFooter"
  [class.mobile-map-shell]="showMobileMapShell"
  [class.search-shell]="showChrome && showSearch && !isAuthShell"
  [style.--mobile-map-header-opacity]="mobileMapHeaderOpacity"
  [style.--mcb]="mobileMapControlBackground">
  @if (showChrome && !isAuthShell) {
    @if (isMobile && pageTitle) {
      <app-mobile-page-header
        [class.profile-currency-header]="currentPath === '/my-profile/currency'"
        [class.payment-flow-header]="isAdPaymentRoute"
        [title]="pageTitle"
        [backLabel]="i18n.t('common.back')"
        [showBack]="showMobileHeaderBack"
        [fixed]="true"
        (back)="onMobileHeaderBack()" />
    } @else {
      <!-- Standard header -->
      <header>
      <div class="wraper">
        @if (isMobile && showSearch) {
          <div class="mobile-search-row">
            <button
              type="button"
              class="main-logo mobile-home-logo download-app-trigger"
              aria-haspopup="dialog"
              [attr.aria-label]="i18n.t('static.downloadDialogAria')"
              (click)="appDownloadSheet.open()">
              <img [alt]="i18n.t('shell.logoAlt')" src="/static_images/ic_logo.svg" />
            </button>

            <app-location-search panelClass="mobile-main-search-panel" />

            <button
              type="button"
              class="custom-btn filters-btn mobile-main-filters-btn"
              style="position: relative;"
              [attr.aria-label]="i18n.t('shell.filters')"
              (click)="openFilters($event)">
              <img alt="Filters" src="/static_images/ic_filters.svg" />
              @if (hasActiveFilters) {
                <span aria-hidden="true" class="filter-active-dot" style="position:absolute;right:-3px;top:-3px;width:16px;height:16px;border:2px solid #fff;border-radius:50%;background:#ff3b30;pointer-events:none;"></span>
              }
            </button>
          </div>
        } @else {
          @if (pageTitle) {
            <a routerLink="/" class="shell-page-title-link">
              <h2 class="shell-page-title">{{ pageTitle }}</h2>
            </a>
          } @else if (showSearch) {
            <button
              type="button"
              class="main-logo download-app-trigger"
              aria-haspopup="dialog"
              [attr.aria-label]="i18n.t('static.downloadDialogAria')"
              (click)="appDownloadSheet.open()">
              <img [alt]="i18n.t('shell.logoAlt')" src="/static_images/ic_logo.svg" />
            </button>
          } @else {
            <a routerLink="/" class="main-logo">
              <img [alt]="i18n.t('shell.logoAlt')" src="/static_images/ic_logo.svg" />
            </a>
          }

          <div class="float-right pt-1">
            @if (showSearch) {
              <app-location-search>
                <button
                  type="button"
                  class="custom-btn filters-btn"
                  style="position: relative;"
                  [attr.aria-label]="i18n.t('shell.filters')"
                  (click)="openFilters($event)">
                  <img alt="Filters" src="/static_images/ic_filters.svg" />
                  @if (hasActiveFilters) {
                    <span aria-hidden="true" class="filter-active-dot" style="position:absolute;right:-3px;top:-3px;width:16px;height:16px;border:2px solid #fff;border-radius:50%;background:#ff3b30;pointer-events:none;"></span>
                  }
                </button>
              </app-location-search>
            }
            @if (!isMobile) {
            <a
              [routerLink]="isAuthenticated() ? '/ad/list' : '/login'"
              class="custom-btn header-action-btn header-add-btn"
              [attr.aria-label]="i18n.t('shell.addListing')">
              <img [alt]="i18n.t('shell.addListing')" src="/static_images/ic_ads_plus.svg" />
            </a>
            <a
              [routerLink]="isAuthenticated() ? '/favourites' : '/login'"
              class="custom-btn header-action-btn fav-btn"
              [attr.aria-label]="i18n.t('shell.favourites')">
              <img alt="Favorites" src="/static_images/ic_fav.svg" />
            </a>
            <a
              [attr.href]="isAuthenticated() ? '/agent' : '/login'"
              class="custom-btn header-action-btn header-agent-btn"
              [attr.aria-label]="i18n.t('shell.mobileAgent')"
              (click)="openAgent($event)">
              <img [alt]="i18n.t('shell.mobileAgent')" src="/static_images/ic_ai_integrations.svg" />
            </a>
            <a
              [routerLink]="isAuthenticated() ? '/chat' : '/login'"
              class="custom-btn header-action-btn chat-btn"
              [attr.aria-label]="i18n.t('shell.chat')"
              (click)="openChat($event)">
              <img alt="Chat messages" src="/static_images/ic_chat.svg" />
              @if (chatUnreadCount() > 0) {
                <span class="chat-unread-badge">{{ formatUnreadCount(chatUnreadCount()) }}</span>
              }
            </a>
            <a
              [routerLink]="isAuthenticated() ? '/my-profile' : '/login'"
              class="custom-btn header-action-btn header-profile-btn"
              [attr.aria-label]="i18n.t('shell.profile')">
              <img alt="Profile" src="/static_images/ic_profile.svg" />
            </a>
          }

            <div class="custom-menu user-menu" [class.open]="menuOpen">
              <ul class="menu">
                <li class="menu-item">
                  @if (isAuthenticated()) {
                    <a routerLink="/my-profile" class="menu-link">{{ i18n.t('shell.profile') }}</a>
                  } @else {
                    <button type="button" class="menu-link menu-btn" (click)="openGuestLogin($event)">{{ i18n.t('shell.profile') }}</button>
                  }
                </li>
                <li class="menu-item">
                  <a routerLink="/contacts" class="menu-link">{{ i18n.t('shell.contacts') }}</a>
                </li>
                <li class="menu-item mt-2">
                  <a routerLink="/terms" class="menu-link">{{ i18n.t('shell.terms') }}</a>
                </li>
                <li class="menu-item mt-2">
                  <a routerLink="/privacy" class="menu-link">{{ i18n.t('shell.privacyPolicy') }}</a>
                </li>
                <li class="menu-item mt-2">
                  @if (isAuthenticated()) {
                    <button type="button" class="menu-btn" (click)="openFeedbackModal($event)">{{ i18n.t('shell.feedback') }}</button>
                  } @else {
                    <a routerLink="/login" class="menu-btn">{{ i18n.t('shell.feedback') }}</a>
                  }
                </li>
                <li class="menu-item mt-3">
                  @if (isAuthenticated()) {
                    <button type="button" class="menu-btn" (click)="onLogout($event)">{{ i18n.t('shell.logout') }}</button>
                  } @else {
                    <a routerLink="/login" class="menu-btn">{{ i18n.t('shell.login') }}</a>
                  }
                </li>
              </ul>
            </div>

            @if (menuOpen) {
              <button type="button" class="menu-backdrop" (click)="closeMenu()"></button>
            }

            @if (feedbackOpen) {
              <button
                type="button"
                class="feedback-backdrop"
                style="position:fixed;inset:0;border:0;background:rgba(0,0,0,.45);padding:0;z-index:180;"
                (click)="closeFeedbackModal()"></button>
              <div
                class="feedback-modal"
                role="dialog"
                aria-modal="true"
                [attr.aria-label]="i18n.t('shell.feedbackTitle')"
                style="position:fixed;top:50%;left:50%;width:min(100%,315px);transform:translate(-50%,-50%);background:#fff;border-radius:10px;box-shadow:0 18px 50px rgba(15,23,42,.25);z-index:181;overflow:hidden;">
                <div
                  class="feedback-modal-title"
                  style="padding:18px 24px 12px;text-align:center;font-size:18px;font-weight:600;color:#111;">
                  {{ i18n.t('shell.feedbackTitle') }}
                </div>

                <div class="feedback-modal-body" style="padding:0 12px 12px;">
                  <div class="feedback-form-group" style="margin-bottom:12px;">
                    <input
                      [(ngModel)]="feedbackForm.name"
                      type="text"
                      class="feedback-control"
                      style="width:100%;box-sizing:border-box;border:1px solid #2f2f2f;border-radius:8px;background:#fff;color:#111;font-size:14px;line-height:1.4;padding:10px 12px;outline:none;"
                      [placeholder]="i18n.t('shell.feedbackNamePlaceholder')" />
                  </div>

                  <div class="feedback-form-group" style="margin-bottom:12px;">
                    <input
                      [(ngModel)]="feedbackForm.phone"
                      type="text"
                      class="feedback-control"
                      style="width:100%;box-sizing:border-box;border:1px solid #2f2f2f;border-radius:8px;background:#fff;color:#111;font-size:14px;line-height:1.4;padding:10px 12px;outline:none;"
                      [placeholder]="i18n.t('shell.feedbackPhonePlaceholder')" />
                  </div>

                  <div class="feedback-form-group" style="margin-bottom:12px;">
                    <textarea
                      [(ngModel)]="feedbackForm.message"
                      class="feedback-control feedback-textarea"
                      rows="5"
                      style="width:100%;box-sizing:border-box;border:1px solid #2f2f2f;border-radius:8px;background:#fff;color:#111;font-size:14px;line-height:1.4;padding:10px 12px;outline:none;min-height:132px;resize:vertical;"
                      [placeholder]="i18n.t('shell.feedbackMessagePlaceholder')"></textarea>
                  </div>

                  @if (feedbackError) {
                    <p class="feedback-error" style="margin:0 0 12px;text-align:center;font-size:13px;color:#d7441a;">{{ feedbackError }}</p>
                  }

                  @if (feedbackSuccess) {
                    <p class="feedback-success" style="margin:0 0 12px;text-align:center;font-size:13px;color:#1f8f46;">{{ feedbackSuccess }}</p>
                  }

                  <div class="feedback-actions" style="display:grid;grid-template-columns:64px 1fr;gap:8px;">
                    <button
                      type="button"
                      class="feedback-close-btn"
                      style="display:inline-flex;align-items:center;justify-content:center;border:1px solid #3f3f3f;border-radius:8px;min-height:34px;background:#fff;cursor:pointer;"
                      (click)="closeFeedbackModal()">
                      <img src="/static_images/ic_cross.svg" [alt]="i18n.t('shell.close')" style="width:18px;height:18px;" />
                    </button>
                    <button
                      type="button"
                      class="feedback-submit-btn"
                      style="border:0;border-radius:8px;min-height:34px;background:#2B98FC;color:#fff;font-size:14px;font-weight:600;cursor:pointer;"
                      [disabled]="isFeedbackSending"
                      (click)="submitFeedback()">
                      {{ isFeedbackSending ? i18n.t('shell.sending') : i18n.t('shell.send') }}
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      </header>
    }
  }

  @if (isAuthShell) {
    <!-- Auth shell: logo-only header -->
    <header class="auth-header">
      <div class="wraper">
        <a routerLink="/" class="main-logo">
          <span>Real</span>ty
        </a>
      </div>
    </header>
  }

  <div
    class="content"
    [class.content-with-shell]="showChrome || isAuthShell"
    [class.auth-content]="isAuthShell"
    [class.content-with-mobile-footer]="showMobileFooter">
    <router-outlet />
  </div>

  @if (showDesktopChatOverlay) {
    <aside class="desktop-chat-overlay">
      <app-chat [embeddedDesktop]="true" />
    </aside>
  }

  @if (showDesktopAgentOverlay) {
    <aside class="desktop-chat-overlay desktop-agent-overlay">
      <app-ai-agent [embeddedDesktop]="true" />
    </aside>
  }

  @if (showMobileFooter) {
    <footer class="mobile-footer-nav">
      <a
        routerLink="/"
        class="custom-btn control-btn home-btn"
        [class.active]="isMobileFooterActive('home')"
        [attr.aria-label]="i18n.t('shell.mobileHome')">
        <div class="btn-icon"><img alt="" src="/static_images/ic_home.svg" /></div>
        <span class="btn-label">{{ i18n.t('shell.mobileHome') }}</span>
      </a>
      <a
        [routerLink]="isAuthenticated() ? '/favourites' : '/login'"
        class="custom-btn control-btn favourites-btn"
        [class.active]="isMobileFooterActive('favourites')"
        [attr.aria-label]="i18n.t('shell.mobileLikes')">
        <div class="btn-icon"><img alt="" src="/static_images/ic_fav.svg" /></div>
        <span class="btn-label">{{ i18n.t('shell.mobileLikes') }}</span>
      </a>
      <a
        [attr.href]="isAuthenticated() ? '/agent' : '/login'"
        class="custom-btn control-btn agent-btn"
        [class.active]="isMobileFooterActive('agent')"
        [attr.aria-label]="i18n.t('shell.mobileAgent')"
        (click)="openAgent($event)">
        <div class="btn-icon"><img alt="" src="/static_images/ic_ai_integrations.svg" /></div>
        <span class="btn-label">{{ i18n.t('shell.mobileAgent') }}</span>
      </a>
      <a
        [routerLink]="isAuthenticated() ? '/chat' : '/login'"
        class="custom-btn control-btn chat-btn"
        [class.active]="isMobileFooterActive('chat')"
        [attr.aria-label]="i18n.t('shell.mobileChat')">
        <div class="btn-icon"><img alt="" src="/static_images/ic_chat.svg" /></div>
        <span class="btn-label">{{ i18n.t('shell.mobileChat') }}</span>
        @if (chatUnreadCount() > 0) {
          <span class="chat-unread-badge">{{ formatUnreadCount(chatUnreadCount()) }}</span>
        }
      </a>
      <a
        [routerLink]="isAuthenticated() ? '/my-profile' : '/login'"
        class="custom-btn control-btn user-profile-btn"
        [class.active]="isMobileFooterActive('profile')"
        [attr.aria-label]="i18n.t('shell.mobileProfile')">
        <div class="btn-icon"><img alt="" src="/static_images/ic_profile.svg" /></div>
        <span class="btn-label">{{ i18n.t('shell.mobileProfile') }}</span>
      </a>
    </footer>
  }

  @if ((showChrome || isAuthShell) && showFooter) {
    <footer [class.auth-footer]="isAuthShell">
      <div class="wraper">
        <span class="copy">{{ i18n.t('shell.footerCopyright') }}</span>

        <div class="float-right">
          <a routerLink="/contacts" class="underline-link ml-3">{{ i18n.t('shell.contacts') }}</a>
          <a routerLink="/terms" class="underline-link ml-3">{{ i18n.t('shell.terms') }}</a>
          <a routerLink="/privacy" class="underline-link ml-3">{{ i18n.t('shell.privacyPolicy') }}</a>
        </div>
      </div>
    </footer>
  }
</div>
<app-download-sheet #appDownloadSheet />
